fragment ConfigurationFragment on Configuration {

    id

    change_billing_address_email

    bacs_title
    bacs_description

    quote_company_name
    quote_pdf_filename
    quote_pdf_logo_url
    quote_pdf_footer_text

    quote_attach_file_original_filename
    quote_attach_file_fs_filename

    order_export_ftp_enabled
    order_export_ftp_email
    order_export_ftp_host
    order_export_ftp_user
    order_export_ftp_password
    order_export_ftp_path

    quote_export_ftp_enabled
    quote_export_ftp_host
    quote_export_ftp_user
    quote_export_ftp_password
    quote_export_ftp_path
}